<div class="iso-datepicker-container" *ngIf="form" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>{{'iso-datepicker.date-of-incident' | translate}}</mat-label>
    <input matInput [matDatepicker]="occurred" [max]="maxDate" formControlName="incidentDate"/>
    <mat-datepicker-toggle [for]="occurred" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #occurred></mat-datepicker>
  </mat-form-field>
</div>
